const translations = {
    addLocation: 'Add a Location',
    back: 'Back',
    myServiceProviderDetails: 'My Service Provider Details'
};

export default translations;
